module.exports = __webpack_public_path__ + "img/VickyDaniels.d69c9781.jpg";